import { render, staticRenderFns } from "./displayAdvertising.vue?vue&type=template&id=3172fffe&scoped=true"
import script from "./displayAdvertising.vue?vue&type=script&lang=js"
export * from "./displayAdvertising.vue?vue&type=script&lang=js"
import style0 from "./displayAdvertising.vue?vue&type=style&index=0&id=3172fffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3172fffe",
  null
  
)

export default component.exports